<script>
  import { onMount } from 'svelte'
  import { navigationManager } from './navigation-manager.js'

  let announcement = $state('')

  onMount(() => navigationManager.afterNavigate(() => {
    requestAnimationFrame(() => {
      const route_root = document.querySelector('[data-route-content]') || document.querySelector('main')
      const active_page = route_root?.querySelector('[data-route-page]:not([hidden])') || route_root
      const heading = active_page?.querySelector('h1')
      const focus_target = heading || active_page

      if (focus_target) {
        focus_target.setAttribute('tabindex', '-1')
        focus_target.focus({ preventScroll: true })
      }

      const label = heading?.textContent?.trim() || document.title || 'Page'
      announcement = ''
      requestAnimationFrame(() => {
        announcement = `${label}, page loaded`
      })
    })
  }))
</script>

<div class="sr-only" aria-live="polite" aria-atomic="true">{announcement}</div>
